<div id="dropin-container"></div>
<button #submitButton [hidden]="!mostrarBotonActualizar" class="btn btn-primary w-100 btn-lg" id="submit-button">
  Guardar cambios
</button>
